import {KEY} from './KEY';

export const HTML_ID = KEY;
